import CaClinicProfile from "../models/domain/CaClinicProfile";
import CaProfile from "../models/domain/CaProfile";
import CaProfileRaw from "../models/domain/CaProfileRaw";

export default class CaProfileMapper {
  static mapRawToModel(raw: CaProfileRaw): CaProfile {
    return new CaProfile(
      raw.caId,
      raw.name,
      raw.email,
      raw.mobile,
      (raw.clinics ?? []).map(
        (c) => new CaClinicProfile(c.clinicId, c.clinicName),
      ),
    );
  }

  static mapResponseProfileToModel(profile: CaProfileRaw): CaProfile {
    return CaProfileMapper.mapRawToModel(profile);
  }
}
